import { useState, useEffect } from 'react';
import axiosClient from "../service/axiosClient";
import { IHolidayPaymentDTO } from '@interfaces/IHolidayPaymentDTO';


export interface UseHolidayPaymentsResult {
  holidayPayments: IHolidayPaymentDTO[];
  isLoading: boolean;
  error: string | null;
}

export const useHolidayPayments = (periodStart: Date | null): UseHolidayPaymentsResult => {
  const [holidayPayments, setHolidayPayments] = useState<IHolidayPaymentDTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setError(null);

    const fetchData = async () => {
      try {
        let formattedPeriodStart: string | null = null;
        if (periodStart) {
          const newPeriodStart = new Date(periodStart.getTime());
          newPeriodStart.setUTCHours(0, 0, 0, 0);
          formattedPeriodStart = newPeriodStart.toISOString();
        }

        const response = await axiosClient.get("/api/holiday_payments", {
          params: { periodStart: formattedPeriodStart }
        });

        if (isMounted) {
          setHolidayPayments(response.data);
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Error fetching holiday payments:', error);
        if (isMounted) {
          setError('Failed to load data. Please try again.');
          setIsLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [periodStart]);

  return { holidayPayments, isLoading, error };
};

export default useHolidayPayments;